const types = {
    AUTH_LOGIN: 'auth/login',
    AUTH_LOGOUT: 'auth/logout',
    AUTH_IS_AUTHENTICATED: 'auth/isAuthenticated',
    AUTH_RENEW_PASSWORD: 'auth/renewPassword',
    AUTH_SET_AUTH_USER_INFO: 'auth/setAuthUserInfo',
    AUTH_API_ERROR: 'auth/authAPIError',
    UPDATE: 'all/update',
    SET_LOCATION_NAME: 'SET_LOCATION_NAME'
}

export {types};